<template>
<div class="v-spinner spinner-centrado" v-show="loading" v-if="propLoading">
    <div class="v-sync v-sync1" v-bind:style="[spinnerStyle,spinnerDelay1]">
    </div><div class="v-sync v-sync2" v-bind:style="[spinnerStyle,spinnerDelay2]">
    </div><div class="v-sync v-sync3" v-bind:style="[spinnerStyle,spinnerDelay3]">
    </div>
  </div>
  <div id="inspire" class="fuente" v-else>
    <v-toolbar class="nav" dense>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #294697"
        v-if="isMobileOrTablet"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn style="background-color: #294697;" dark small depressed @click="logout">
        NOVA
        <v-icon>mdi-backburger</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container fluid fill-height>
      <v-layout>
        <v-flex xs12 sm2 md2>
          <v-navigation-drawer
            class="drawer"
            v-model="drawer"
            :temporary="isMobileOrTablet"
            absolute
            :permanent="!isMobileOrTablet"
            :width="280"
            :overlay-opacity="0"
            :hide-overlay="true"
          >
            <div v-if="isMobileOrTablet" class="close-button-container">
              <v-btn
                icon
                @click="drawer = false"
                class="close-btn"
                color="white"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div class="fondo-con-logo">
              <v-img
                class="fondo"
                :src="require('../../.././assets/PANTALLA-03.png')"
                contain
              ></v-img>
              <v-img
                class="logo"
                :src="require('../../.././assets/nova/NOMBREBLANCO.png')"
                max-height="100"
                contain
              ></v-img>
            </div>
            <v-list dense>
              <div class="name">{{nombre}}</div>
              <v-list-item-group color="#294697">
                <v-list-item
                  :to="itemInicio.link"
                  @click="handleNavigation"
                >
                  <v-list-item-icon>
                    <v-icon>{{itemInicio.icon}}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{itemInicio.text}}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content style="width:144px">
                    <v-menu
                      :nudge-width="30"
                      offset-x
                    >
                      <template v-slot:activator="{ on }">
                        <v-list-item-title v-on="on">
                          <v-icon>mdi-chart-histogram</v-icon>
                          <span style="margin-left:12%">REPORTES</span>
                        </v-list-item-title>
                      </template>
                      <v-list dense>
                        <!-- REPORTE POR FECHA (visible para todos) -->
                        <v-list-item
                          v-for="(item, i) in subMenu"
                          :key="i"
                          :to="item.link"
                          @click="handleNavigation"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="item.icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="item.text"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        
                        <!-- REPORTE CALLCENTER (solo para cargos 4 y 58) -->
                        <v-list-item
                          v-if="mostrarReporteCallcenter"
                          :to="itemReporteCallcenter.link"
                          @click="handleNavigation"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="itemReporteCallcenter.icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="itemReporteCallcenter.text"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        
                        <!-- REPORTE GENERAL (solo para cargo 9 - Control Interno) -->
                        <v-list-item
                          v-if="mostrarReporteGeneral"
                          :to="itemReporteGeneral.link"
                          @click="handleNavigation"
                        >
                          <v-list-item-icon>
                            <v-icon v-text="itemReporteGeneral.icon"></v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title v-text="itemReporteGeneral.text"></v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="closeModule">
                  <v-list-item-icon>
                    <v-icon>mdi-power-standby</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title @click="logout"
                      >CERRAR MODULO</v-list-item-title
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-main>
            <v-container>
              <router-view to="children"/>
            </v-container>
          </v-main>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";

export default {
  name: 'SyncLoader',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#294697'
    },
    size: {
      type: String,
      default: '30px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      propLoading: this.loading,
      nombre: localStorage.getItem('nombre') || 'Usuario',
      cedula: localStorage.getItem('cedula') || '',
      id: localStorage.getItem('id') || '',
      idCargo: parseInt(localStorage.getItem('idCargo')) || 0,
      drawer: null,
      
      // Menú principal
      itemInicio: { 
        text: "INICIO", 
        icon: "mdi-home", 
        link: "/Callcenter/Reportes/Inicio"
      },
      
      // Submenú base (visible para todos)
      subMenu: [
        { 
          text: "REPORTE POR FECHA", 
          icon: "mdi-calendar-multiple", 
          link: "/Callcenter/Reportes/Fecha"
        },
      ],
      
      // Reporte Callcenter (solo para cargos específicos)
      itemReporteCallcenter: {
        text: "REPORTE CALLCENTER",
        icon: "mdi-phone-alert",
        link: "/Callcenter/Reportes/Fechas"
      },
      
      // 👇 NUEVO: Reporte General (solo para Control Interno - cargo 9)
      itemReporteGeneral: {
        text: "REPORTE GENERAL",
        icon: "mdi-chart-bar",
        link: "/Callcenter/Reportes/General"
      },
      
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-syncStretchDelay',
        animationDuration: '0.6s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.07s'
      },
      spinnerDelay2: {
        animationDelay: '0.14s'
      },
      spinnerDelay3: {
        animationDelay: '0.21s'
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    isTablet() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
    },
    isMobileOrTablet() {
      return this.isMobile || this.isTablet;
    },
    
    // 👇 Computed property para mostrar REPORTE CALLCENTER
    mostrarReporteCallcenter() {
      return this.idCargo === 4 || this.idCargo === 58;
    },
    
    // 👇 Computed property para mostrar REPORTE GENERAL (solo cargo 9)
    mostrarReporteGeneral() {
      return this.idCargo === 9;
    }
  },
  methods: {
    logout() {
      this.$router.push("/user");
    },
    closeModule(){
      window.close();
    },
    obtenerUser() {
      axios.get(`${env.endpoint}callcenter/iniciar`).then(res => {
        if (res.data && res.data.user) {
          this.nombre = res.data.user.nombre
          this.cedula = res.data.user.cedula
          this.id = res.data.user.id
          this.idCargo = parseInt(res.data.user.idCargo) || 0
          // Guardar en localStorage para que otros componentes puedan acceder
          localStorage.setItem("idCargo", this.idCargo.toString());
        } else if (res.data) {
          this.nombre = res.data.nombre || this.nombre
          this.cedula = res.data.cedula || this.cedula
          this.id = res.data.id || this.id
          this.idCargo = parseInt(res.data.idCargo) || this.idCargo
          // Guardar en localStorage para que otros componentes puedan acceder
          localStorage.setItem("idCargo", this.idCargo.toString());
        }
      }).catch(error => {
        // fallback
      });
    },
    handleNavigation() {
      if (this.isMobileOrTablet) {
        this.drawer = false;
      }
    }
  },
  mounted(){
    setTimeout(() => {
      this.propLoading = false
    }, 1000);
    
    this.obtenerUser()
    
    // Responsive: abrir drawer por defecto solo en desktop
    this.drawer = !this.isMobileOrTablet;
  },
}
</script>

<style>
.fondo-con-logo {
  position: relative;
  width: 100%;
  height: 250px;
  background-color: #294697;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.fondo-con-logo .fondo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
}

.fondo-con-logo .logo {
  position: relative;
  z-index: 2;
}
.drawer {
  z-index: 1000 !important;
}
.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}
.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}
</style>
